import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@embraceit/angularcore/tms';

@Component({
    selector: 'planning-portal-discard-unsaved-changes',
    imports: [CommonModule, ConfirmDialogModule,ButtonModule, TranslatePipe],
    templateUrl: './discard-unsaved-changes.component.html',
    styles: []
})
export class DiscardUnsavedChangesComponent {
    description!: string;
    title! :string;
    name! : string;
    constructor(
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig
    ) {
      this.description = this.config.data.description;
      this.title = this.config.data.title;
      this.name = this.config.data.name
    }
  
    closeModal(isConfirm: boolean) {
      this.ref.close(isConfirm);
    }
}
